<div class="content-block wizard-container">

  <div class="wizard-header">
    <h4 class="wizard-title">Attività Giornaliera</h4>
    <p class="wizard-description">
      Seleziona l’operazione che desideri eseguire per proseguire.
    </p>
  </div>

  <div class="wizard-actions div-buttons">
    <dx-button class="dx-button-orange" stylingMode="contained" text="Consegna Articoli" type="normal"
      (onClick)="onConsegnaArticoli()">
    </dx-button>

    <dx-button class="dx-button-orange" stylingMode="contained" text="Restituzione Articoli" type="normal"
      (onClick)="onRestituzioneArticoli()">
    </dx-button>
  </div>
  <div class="row div-grid grid-articoli">
    <dx-data-grid [dataSource]="listArticoli" [showBorders]="true" [columnAutoWidth]="true" noDataText="Nessun articolo da restituire"
    rowAlternationEnabled="true">

      <dxo-editing mode="row" [allowAdding]="false" [allowUpdating]="false" [allowDeleting]="false" [useIcons]="true">
      </dxo-editing>
      <dxi-column dataField="id" [visible]="false"></dxi-column>

      <dxi-column dataField="descrizione" [allowFiltering]="false" [allowSorting]="false" caption="Articolo" alignment="center">
      </dxi-column>
      <dxi-column caption="Quantità" dataField="quantita" type="number" alignment="center">
      </dxi-column>
      <dxi-column dataField="idDipendente" caption="Dipendente" alignment="center">
        <dxo-lookup [dataSource]="listDipendenti" valueExpr="id" [displayExpr]="getDipendenteDisplayExpr"></dxo-lookup>
      </dxi-column>

    </dx-data-grid>
  </div>

</div>